import React from "react";
import { Link } from "react-router-dom";
import HeroSection from "./components/HeroSection1"; // Optional banner or title section
import "./Dashboard.css";

const Dashboard = () => {
    return (
        <div className="dashboard-container">
            <HeroSection />
            <nav className="dashboard-nav">
                
            </nav>
        </div>
    );
};
export default Dashboard;